<template>
 <div class="carrusel-container-personajes">
  <div class="container">
    <div class="row">
      <div class="col-12 mb-5">
        <h2 class="text-center carousel-title">Desinformación en acción</h2>
      </div>
      <div class="col-12">
        <VueSlickCarousel v-bind="settings" :arrows="true" :dots="true">
          <div :key="ix" v-for="(img, ix) in images" class="active carousel-item">
            <div class="cloud-message" :class="{'turn': img.turn == true}" v-html="img.title"></div>
            <img
              :src="`${img.src}`"
              class="img-carrusel"
              blank="true"
            >
          </div>
        </VueSlickCarousel>

      </div>
    </div>
  </div>
 </div>
</template>

<style>

  .carousel-title {
    font-size: 31px;
    color: #fff;
    font-family: "Fira Sans",sans-serif;
  }

  .carrusel-container-personajes {
    background-color: #000;
    background-repeat: no-repeat;
    background-size: cover;
    padding: 45px 0;
    width: 100%;
    overflow: hidden;
  }

  .carousel-item {
    padding: 0 0;
  }

  .slick-prev {
    left: 0;
    z-index: 99;
  }
  
  .slick-next {
    right: 0;
    z-index: 99;
  }

  .slick-dots li button {
    font-size: 0;
    line-height: 0;
    display: block;
    width: 20px;
    height: 20px;
    padding: 5px;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 0.25;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-dots li.slick-active button:before {
    opacity: 1;
    color: #929292;
  }

  .slick-dots li button:before {
    font-family: 'slick';
    font-size: 25px;
    line-height: 20px;
    position: absolute;
    top: 0;
    left: 0;
    width: 20px;
    height: 20px;
    content: '•';
    text-align: center;
    opacity: 1;
    color: white;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .slick-prev:before, .slick-next:before {
    font-family: 'slick';
    font-size: 45px;
    line-height: 1;
    opacity: 0.75;
    color: #fff;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .cloud-message {
    width: 100%;
    color: #fff;
    max-width: 320px;
    margin: 35px auto 0 auto;
    background-color: #000;
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
    transform: rotate(5deg);
    font-family: "Noto Sans";
    box-shadow: 0px 0px 4px 2px #91919161;

    &.turn {
      transform: rotate(-5deg);
    }
  }

  .img-carrusel {
    width: 100%;
    max-width: 420px;
    margin: 0 auto 0 auto;
    display: block;
    pointer-events: none;
  }

  .carousel-intro {
    font-weight: bold;
  }



</style>

<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'


export default {
  name: 'Carousel',
  components: {
    VueSlickCarousel
  },
  setup() {
    const onSwiper = (swiper) => {
      console.log(swiper);
    };
    const onSlideChange = () => {
      console.log('slide change');
    };
    return {
      onSwiper,
      onSlideChange,
    };
  },
  data() {
	return {
      settings: {
        "dots": true,
        "focusOnSelect": true,
        "infinite": true,
        "speed": 500,
        "slidesToShow": 2,
        "slidesToScroll": 2,
        "touchThreshold": 6,
        "responsive": [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 320,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
          },
        },
      ],
      },
      images: [
        {
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/01_armas_quimicas.png',
          alt: 'Image 2',
          turn: false,
          title: 'La CDSL publicó en sus redes sociales la imagen de una supuesta carretera de Loreto bombardeada con “armas químicas y biológicas del Gobierno” el 27 de septiembre último. <strong>EL FOCO</strong> confirmó que la foto no pertenece a ninguna vía pública de la región. (Foto: Facebook)'
        },
        {
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/02_incendios_forestales.png',
          alt: 'Image 2',
          turn: true,
          title: 'Otro de las teorías alarmistas y desinformadoras de la CDSL es que las ONG causaron los incendios forestales que azotaron la amazonía peruana en septiembre último. “Ahora incendian la Amazonía para decir que es el calentamiento global”, escribieron en la publicación del 17 de septiembre pasado. (Foto: Facebook)'
        },
        {
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/03_nota_proycontra.png',
          alt: 'Image 2',
          turn: false,
          title: 'Luego de que se archivara la propuesta del congresista Jorge Morante para modificar la Ley PIACI, el medio digital <i>Pro y Contra</i> difundió la posición de la CDSL. “Congresistas traicionaron a Loreto”, es el titular de una nota web de junio de 2023. '
        },
        {
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/04_comunicado_kene.png',
          alt: 'Image 2',
          turn: true,
          title: 'Una de las víctimas de la campaña de desinformación es Lucila Pautrat, directora de Kené, institución de estudios ambientales y forestales. En marzo último, la CDSL acusó a la organización de impedir toda actividad económica en la Amazonía.'
        }, {
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/05_camara_comercio.png',
          alt: 'Image 2',
          turn: false,
          title: 'La Cámara de Comercio de Loreto se sumó en junio último a la red de desinformación. En la narrativa creada por el gremio empresarial, los pueblos indígenas reciben financiamiento de Alemania y Noruega. (Foto: Facebook)'
        },{
          src: '/wp-content/interactivos/factchecking-loreto/carrusel/06_diario_laselva.png',
          alt: 'Image 2',
          turn: true,
          title: 'El diario digital <i>La Selva</i> ha dedicado sendas portadas para desinformar sobre la creación de reservas indígenas. En su portada del 18 de marzo último, reprodujeron las declaraciones del gerente regional Erwin Florett: “Estas reservas protegidas por una ley perniciosa y ONG extremistas están segmentando a Loreto”. (Foto: Facebook)'
        }
      ]
    }
  }
};
</script>
